






















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
  model: {
        prop: 'modelValue',
        event: 'change'
    }
})
export default class CheckboxControl extends Vue {
    @Prop({ default: false })
    private modelValue!: any;
    @Prop({ default: true })
    private trueValue!: any;
    @Prop({ default: false })
    private falseValue!: any;
    @Prop({ type: Boolean, default: false })
    private disabled!: boolean;
    @Prop({ type: String, default: '#e6e6e6' })
    private borderColorFalse!: string;
    @Prop({ type: String, default: '#ba0c2f' })
    private borderColorTrue!: string;
    @Prop({ type: String, default: '#FFF' })
    private backgroundColorFalse!: string;
    @Prop({ type: String, default: '#FFF' })
    private backgroundColorTrue!: string;
    @Prop({ type: String, default: '#ba0c2f' })
    private checkmarkColor!: string;

    get shouldBeChecked() {
        return this.modelValue === this.trueValue
    }

    get backgroundAndBorderColors() {
        let borderColor = this.shouldBeChecked ? this.borderColorTrue : this.borderColorFalse;
        let backgroundColor = this.shouldBeChecked ? this.backgroundColorTrue : this.backgroundColorFalse;
        return {'border-color': borderColor, 'background-color': backgroundColor};
    }

    get isDisabledStyle() {
        let displayResult = this.disabled ? 'inherit' : 'none';
        return {'display': displayResult};
    }

    updateInput(event: any) {
        if (this.disabled) {
            return;
        }
        let isChecked = event.target.checked;
        this.$emit('change', isChecked ? this.trueValue : this.falseValue);
    }
}
